import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Avatar from '@material-ui/core/Avatar';
const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    background: "white"
  },
  row: {
    display: 'flex'
  },
  pad: {
    marginLeft: '16px',
    background: "white"
  }
}));

export default function Contact() {
  const classes = useStyles();

  return (
    <div>
      <List className={classes.root}>
        <a href="mailto:umakant_bt2k17@dtu.ac.in" target="_blank">
          <ListItem>
            <ListItemAvatar>
              <Avatar>
                <i className="material-icons">email</i>
              </Avatar>
            </ListItemAvatar>
            <ListItemText primary="umakant_bt2k17@dtu.ac.in" />
          </ListItem>
        </a>

        <a href="mailto:umakantvashishtha98@gmail.com" target="_blank">
          <ListItem>
            <ListItemAvatar>
              <Avatar>
                <i className="material-icons">email</i>
              </Avatar>
            </ListItemAvatar>
            <ListItemText primary="umakantvashishtha98@gmail.com" />
          </ListItem>
        </a>
        <a href="tel:8377073597" target="_blank">
          <ListItem>
            <ListItemAvatar>
              <Avatar>
                <i className="material-icons">phone</i>
              </Avatar>
            </ListItemAvatar>
            <ListItemText primary="8377073597" />
          </ListItem>
        </a>      
      </List>
      <div className={classes.row}>
        <a href="http://github.com/umakantv/"><Avatar className={classes.pad}>
          <img src="https://s3.amazonaws.com/coursera_assets/growth_account_profile/github_icon.svg" width="100%"></img>
        </Avatar></a>
        <a href="https://www.linkedin.com/in/umakant-vashishtha/"><Avatar className={classes.pad}>
          <img src="https://s3.amazonaws.com/coursera_assets/growth_account_profile/linkedIn_icon.svg" width="100%"></img>
        </Avatar></a>
        <a href="https://www.codechef.com/users/ranchov007"><Avatar className={classes.pad}>
          <img src="https://s3.amazonaws.com/codechef_shared/sites/all/themes/abessive/images/user_default_thumb.jpg" width="100%"></img>
        </Avatar></a>
        <a href="https://www.hackerrank.com/ranchov"><Avatar className={classes.pad}>
          <img src="https://hrcdn.net/fcore/assets/brand/h_mark_sm-966d2b45e3.svg" width="100%"></img>
        </Avatar></a>
        <a href="https://www.coursera.org/user/5aedb85fe3e8ce348707f49389066cd4"><Avatar className={classes.pad}>
          <img src="https://raw.githubusercontent.com/umakantv/info/gh-pages/images/coursera.jpg" width="100%"></img>
        </Avatar></a>
      </div>
    </div>
  );
}
